import { COUNTRY_ALPHA_2_CODES, CountryAlpha2Code } from '../constants';

export const checkIsAllowedCountryCode = (alpha2CountryCode: string) => (
  !!alpha2CountryCode && alpha2CountryCode.length === 2 && !!COUNTRY_ALPHA_2_CODES[alpha2CountryCode.toUpperCase() as CountryAlpha2Code]
);
